import { DASHBOARD } from "../actions/types";

const initialState = {
  error: null,
  isLoading: false,
  noMoreTests: false,
  loadingMoreTests: false,
  groups: [],
  defaultTests: [],
  communityTemplates: [],
  defaultProjectId: null,
};

const dashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case DASHBOARD.LOAD:
      return { ...state, isLoading: true, ...payload };

    case DASHBOARD.UPDATE:
      return { ...state, isLoading: false, error: null, ...payload };

    case DASHBOARD.RESET:
      return initialState;

    case DASHBOARD.ERROR:
      return { ...state, isLoading: false, error: payload };

    default:
      return state;
  }
};

export default dashboardReducer;
